export function parseSecondsToMinutes(seconds: string | undefined) {
  if (!seconds) {
    return 0;
  }

  const minutes = Number.parseFloat(seconds) / 60;

  return Intl.NumberFormat("pl-PL", {
    maximumFractionDigits: 0,
  }).format(minutes);
}
